module.exports = __webpack_public_path__ + "static/media/12812.c6fda643.jpg";